import { DAYS_OF_WEEK_LOWERCASE_LENGTH_3 } from "constants/daysOfWeek";

/**
 * unit value for the repeated sessions
 * e.g. 1 week, 3 month, ...
 */
export const REPEAT_EVERY_OPTIONS = [1, 2, 3, 4];

/**
 * frequency type value for the repeated sessions
 */
export const REPEAT_INTERVAL_OPTIONS = Object.freeze({
  week: "week",
  month: "month",
  year: "year",
} as const);

/**
 * repeat on days
 * { "sun": "SUN", "mon": "MON",... }
 */
export const REPEAT_ON_DAYS_OPTIONS = Object.freeze(
  DAYS_OF_WEEK_LOWERCASE_LENGTH_3.reduce((prev, curr) => {
    prev[curr] = curr.toUpperCase();
    return prev;
  }, {} as Record<string, string>),
);

/**
 * expire type
 * e.g. on 3 sessions, after 10 sessions, ...
 */
export const REPEAT_END_TYPE_OPTIONS = Object.freeze({
  end_after: { id: "end_after", stringId: "after" },
  end_date: { id: "end_date", stringId: "on" },
} as const);

/**
 * max repeatable session count
 */
export const MAX_SESSIONS = 30;

/**
 * default session count for ends after
 */
export const DEFAULT_ENDS_AFTER_SESSIONS = 5;
